import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import Modal from 'ud-ui/components/modal';
import { deleteBoard } from 'modules/template-editor/store/templates/actions';
import { resetPressedState } from 'modules/template-editor/store/templates/templates';
import useBoards from 'modules/template-editor/ui/hooks/use-boards';
import { useDispatchWithToast } from 'store/use-dispatch-with-toast';

function useDeleteModal() {
  const { t } = useLingui();
  const dispatch = useDispatch();
  const dispatchWithToast = useDispatchWithToast();
  const { activeBoard, isProcessed, isFinished, process } = useBoards();

  const [isOpen, setIsOpen] = useState(false);
  const open = useCallback(() => {
    setIsOpen(true);
  }, []);
  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const onSubmit = useCallback(() => {
    if (!activeBoard) return;
    dispatchWithToast(deleteBoard({ id: activeBoard.id }), { error: msg`Не удалось удалить табло` });
  }, [activeBoard, dispatchWithToast]);

  useEffect(() => {
    if (!isFinished) {
      return;
    }
    if (process !== 'delete board') {
      return;
    }
    close();
    dispatch(resetPressedState());
  }, [close, dispatch, isFinished, process]);

  const entityName = activeBoard?.name;

  return {
    modal: (
      <Modal.Confirm
        show={isOpen}
        title={entityName ? t`Удалить табло «${entityName}»?` : t`Удалить табло?`}
        description={t`Это действие необратимо.`}
        isLoading={isProcessed}
        onConfirm={onSubmit}
        onCancel={close}
      />
    ),
    close,
    open,
  };
}

export default useDeleteModal;
